import $ from "jquery";

const initNotificationDropdown = () => {
  const buttonsCollection = document.getElementsByClassName(
    "js-notification-dropdown"
  );

  if (!buttonsCollection) {
    return;
  }

  const activeClass = "active";
  const ESC_BTN = 27;
  const $document = $(document);

  function showDropdown(buttonElem) {
    buttonElem.classList.add(activeClass);
    buttonElem.isOpened = true;
  }

  function hideDropdown(buttonElem) {
    buttonElem.classList.remove(activeClass);
    buttonElem.isOpened = false;
  }

  function hideAllDropdowns(currentTarget) {
    Array.from(buttonsCollection).forEach((elem) => {
      if (elem === currentTarget) {
        return;
      }
      hideDropdown(elem);
    });
  }

  function createBodyClickHandler(buttonElem) {
    return function bodyClickHandler(event) {
      event.stopPropagation();

      hideDropdown(buttonElem);
      $document.off("click touchstart", bodyClickHandler);
    };
  }

  function createEscapeHandler(buttonElem) {
    return function escapeKeyHandler(event) {
      if (event.keyCode !== ESC_BTN) {
        return;
      }
      hideDropdown(buttonElem);
      $document.on("keyup", escapeKeyHandler);
    };
  }

  Array.from(buttonsCollection).forEach((elem) => {
    elem.isOpened = false;

    $(elem).on("click touchstart", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const targetBtn = event.currentTarget;

      hideAllDropdowns(targetBtn);

      if (!targetBtn.isOpened) {
        showDropdown(targetBtn);
        $document.on("click touchstart", createBodyClickHandler(targetBtn));
        $document.on("keyup", createEscapeHandler(targetBtn));
      } else {
        hideDropdown(targetBtn);
      }
    });
  });
};

export default initNotificationDropdown;
